import * as actionTypes from "../actions/actionTypes";

const initialState = {
  crowdedness: 0,
  oa: 99,
  pm_icon: "pm_1",
  firstLoading: true
};

const mallEnviromentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_MALL_ENVIROMENT_DATA:
      return { ...state, ...payload };

    case actionTypes.SET_MALL_ENVIROMENT_FIRST_LOADING:
      return { ...state, firstLoading: payload };

    default:
      return state;
  }
};

export default mallEnviromentReducer;
